fragment TagFragment on Tag {
    id
    name
}